export const TAB_CLASS =
    "rounded-full border px-4 py-2 text-[0.9375rem] font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground";
export const TAB_ACTIVE_CLASS = "border-primary bg-primary text-primary-foreground hover:bg-primary";
